import React from "react";
import {CourierDetailTable} from "./components/CourierDetailTable";
import {CourierDetailStats} from "./components/CourierDetailStats";

export const CourierDetailTotal = ({
    paymentTransactionsLogCalculation,
    tableData,
    pageParam,
    setPageParam,
    sharedLogFilters,
    fetchDetail
}) => {
    return (
        <div>
            <CourierDetailStats data={paymentTransactionsLogCalculation?.data || {}} />
            <CourierDetailTable
                data={tableData?.data}
                courierNames={paymentTransactionsLogCalculation?.data?.courierNames}
                pageParam={pageParam}
                setPageParam={setPageParam}
                sharedLogFilters={sharedLogFilters}
                fetchDetail={fetchDetail}
            />
        </div>
    );
};
